import WRAP from "WRAP-JS";
import {
  configVolcanicAshDh,
  configVolcanicAshLayer,
  configVolcanicRankDh,
  configVolcanicRankLayer
} from "./config/ConfigAcos";
import LegendAcos from "../legend/LegendAcos";
import { _orderBy, formatTimeZoneDate, formatValidTime, ft2m, m2ft, parseUTCDate } from "../../../utils/FPEUtils";
import WrapOption from "../../../constants/WrapOption";
import axios from "axios";
import reactDom from "react-dom";
import Draggable from "react-draggable";
import { WX_ID_ACOS } from '../../../store/WeatherContentsState';
import TimeController from "../helper/TimeController";
import { nearValidTime } from "../helper/MapUtil";
import { Checkbox, FormControlLabel, makeStyles } from "@material-ui/core";
import { useDisplayOperationState } from "../../../hooks/useDisplayOperation";
import { useRecoilValue } from "recoil";
import { contentsAnimatingStateWithId, contentsCurrentTimeStateWidthId } from "../../../store/AnimatingState";
import { useCallback, useEffect } from "react";
import { useLayoutState } from "../../../store/LayoutState";
import {COMMUNICATE_ERROR_MESSAGE_ACOS_INDEX, COMMUNICATE_ERROR_MESSAGE_ACOS_2D, COMMUNICATE_ERROR_MESSAGE_ACOS_3D, COMMUNICATE_ERROR_MESSAGE_ACOS_WX_WNI_VolcanicAsh_GPV, COMMUNICATE_ERROR_MESSAGE_ACOS_WX_WNI_VolcanicRank, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD } from "../../../constants/ErrorMessage";
import { exWxContentsState } from "../../../store/ExWxContentsState";

class Acos {
  static NAME = WX_ID_ACOS;
  static AshLayerName = 'VolcanicAsh_GPV';
  static RankLayerName = 'volcanicRank';
  static LabelLayer = "AcosLabelLayer";
  FL_ALL_VALUE = "ALLHGT_overlay";

  dispatcher;
  isDark;
  ashLayer;
  rankLayer;
  labelLayer;
  ready = false;
  dhAutoUpdate = true;
  dhAsh;
  dhRank;
  visible;
  altitude = 0;
  elapsed = 0;
  etd;
  latestVolcanoList;
  latestAnnouncedDate;
  validTimeList;
  validTime;
  level = this.FL_ALL_VALUE;
  popupVolcanoList;
  popup;
  rankIndex;
  volcanoAsh2D;
  volcanoAsh3D;
  firstDraw = false;
  viewFtAll = false;
  errorMessageInfo = {};

  // タイムコントローラー
  acosTimeController;
  // タイムコントローラーのリスト
  timeList;
  // 自動更新フラグ
  autoRefresh = true;
  // 噴火時刻
  ERUPTED_TIME_THRESHOLD = 24 * 3600;

  // HGTとFLの対応
  HGT_FL_MAPPING = {
    13106: {FL: "430", FL_V: "FL430"},
    12802: {FL: "420", FL_V: "FL420"},
    12497: {FL: "410", FL_V: "FL410"},
    12192: {FL: "400", FL_V: "FL400"},
    11887: {FL: "390", FL_V: "FL390"},
    11582: {FL: "380", FL_V: "FL380"},
    11278: {FL: "370", FL_V: "FL370"},
    10973: {FL: "360", FL_V: "FL360"},
    10668: {FL: "350", FL_V: "FL350"},
    10363: {FL: "340", FL_V: "FL340"},
    10058: {FL: "330", FL_V: "FL330"},
    9754: {FL: "320", FL_V: "FL320"},
    9449: {FL: "310", FL_V: "FL310"},
    9144: {FL: "300", FL_V: "FL300"},
    8839: {FL: "290", FL_V: "FL290"},
    8534: {FL: "280", FL_V: "FL280"},
    8230: {FL: "270", FL_V: "FL270"},
    7925: {FL: "260", FL_V: "FL260"},
    7620: {FL: "250", FL_V: "FL250"},
    7315: {FL: "240", FL_V: "FL240"},
    7010: {FL: "230", FL_V: "FL230"},
    6706: {FL: "220", FL_V: "FL220"},
    6401: {FL: "210", FL_V: "FL210"},
    6096: {FL: "200", FL_V: "FL200"},
    5791: {FL: "190", FL_V: "FL190"},
    5486: {FL: "180", FL_V: "FL180"},
    5182: {FL: "170", FL_V: "FL170"},
    4877: {FL: "160", FL_V: "FL160"},
    4572: {FL: "150", FL_V: "FL150"},
    4267: {FL: "140", FL_V: "FL140"},
    3962: {FL: "130", FL_V: "FL130"},
    3658: {FL: "120", FL_V: "FL120"},
    3353: {FL: "110", FL_V: "FL110"},
    3048: {FL: "100", FL_V: "FL100"},
    2743: {FL: "090", FL_V: "FL090"},
    2438: {FL: "080", FL_V: "FL080"},
    2134: {FL: "070", FL_V: "FL070"},
    1829: {FL: "060", FL_V: "FL060"},
    1524: {FL: "050", FL_V: "FL050"},
    1219: {FL: "040", FL_V: "FL040"},
    914: {FL: "030", FL_V: "FL030"},
    610: {FL: "020", FL_V: "FL020"},
    305: {FL: "010", FL_V: "FL010"},
    [this.FL_ALL_VALUE]: {FL: "ALL", FL_V: "ALL"}
  };
  HGTS = Object.keys(this.HGT_FL_MAPPING)
    .sort((a,b) => { return a !== this.FL_ALL_VALUE ? b - a : false;})
    .map(value => {
      return {
        HGT: value !== this.FL_ALL_VALUE ? value - 0 : value,
        ...this.HGT_FL_MAPPING[value]
      };
    });

  constructor(isDark) {
    this.acosTimeController = new TimeController(WX_ID_ACOS, {
      label: 'ACOS',
      getTimeList: () => {
        if (this.validTimeList) {
          return this.validTimeList;
        }
        this._updateTimeList();
        return this.validTimeList;
      },
      updated: () => {
        this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
      },
      changeAutoRefresh: (autoFlg) => {
        this.setAutoRefresh(autoFlg);
      },
      updating : () => {
        if (this.ready) {
          this.setViewFtAll(false);
        }
      }
    });
    this.isDark = isDark;

    this.ashLayer = new WRAP.Geo.Layer(Acos.AshLayerName);
    this.rankLayer = new WRAP.Geo.Layer(Acos.RankLayerName);
    this.labelLayer = new WRAP.Geo.Layer(Acos.LabelLayer);
    this.ashLayer.setVisible(false);
    this.ashLayer.setTooltip(this._ashTooltip.bind(this));
    this.rankLayer.setVisible(false);
    this.rankLayer.setTooltip(this._rankTooltip)
    this.labelLayer.setVisible(false);
    this.labelLayer.disableInteraction(true);
  }

  setDispatcher(dispatcher) {
    this.dispatcher = dispatcher;
  }

  setExDispatcher(dispatcher) {
    this.exDispatcher = dispatcher;
  }

  async initialize() {
    await this.initData();
    this.initLayer();
    this.initTimeController();
    this.ready = true;
  }

  initData() {
    return new Promise(allResolve => {

      const dhAsh = this.dhAsh = new WRAP.Data(configVolcanicAshDh);
      this.dhAsh.validate((displayTime, data, content) => {
        return this._validateTime(displayTime, content);
      })
      const dhRank = this.dhRank = new WRAP.Data(configVolcanicRankDh);

      const ashPromise = new Promise(resolve => {
        dhAsh.updated('datalist', timelist => {
          if (this.errorMessageInfo.dataList) {
            this.dispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo.dataList});
            this.errorMessageInfo.dataList = null;
          }
          this._selectBaseValidTime(timelist.index);
          this._loadVolcanicAshConcVector().then(() => {
            resolve(timelist);
          });
        }, () => {
          this.errorMessageInfo.dataList = this.dispatcher({type: 'SHOW_ERROR', payload: {
            message: COMMUNICATE_ERROR_MESSAGE_ACOS_WX_WNI_VolcanicAsh_GPV,
            replacement: {data: 'datalist'},
            additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
          }});
        });
        dhAsh.updated('timelist', () => {
          if (this.errorMessageInfo.timelist) {
            this.dispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo.timelist});
            this.errorMessageInfo.timelist = null;
          }
        }, () => {
          this.errorMessageInfo.timelist = this.dispatcher({type: 'SHOW_ERROR', payload: {
            message: COMMUNICATE_ERROR_MESSAGE_ACOS_WX_WNI_VolcanicAsh_GPV,
            replacement: {data: 'timelist'},
            additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
          }});
        });
        dhAsh.updated('conf', null, () => {
          this.dispatcher({type: 'SHOW_ERROR', payload: {
            message: COMMUNICATE_ERROR_MESSAGE_ACOS_WX_WNI_VolcanicAsh_GPV,
            replacement: {data: 'conf'},
            additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
          }});
        });
        dhAsh.updated('data', null, () => {
          this.dispatcher({type: 'SHOW_ERROR', payload: {
            message: COMMUNICATE_ERROR_MESSAGE_ACOS_WX_WNI_VolcanicAsh_GPV,
            replacement: {data: 'data'},
            additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
          }});
        });
      });

      const rankPromise = new Promise(resolve => {
        dhRank.updated('data', data => {
          if (this.errorMessageInfo.data) {
            this.dispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo.data});
            this.errorMessageInfo.data = null;
          }
          // アイコンの描画順制御の為ソートする
          data.features.sort((a,b)=> {
            if(a.properties.index < b.properties.index) {
              return -1;
            } else if (a.properties.index > b.properties.index) {
              return 1;
            } else {
              return 0;
            }
          });
          resolve(data);
        }, () => {
          this.errorMessageInfo.data = this.dispatcher({type: 'SHOW_ERROR', payload: {
            message: COMMUNICATE_ERROR_MESSAGE_ACOS_WX_WNI_VolcanicRank,
            additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
          }});
        });
      });

      Promise.all([ashPromise, rankPromise]).then(refs => {
        this._createPopupVolcanoList();
        allResolve(refs);
      });
    });
  }

  initLayer() {
    this.ashLayer.configure(this.dhAsh, configVolcanicAshLayer);
    this.rankLayer.configure(this.dhRank, configVolcanicRankLayer);
    this.rankLayer.updated(this._addLabel.bind(this));
    WRAP.Geo.addEventHandler('touch', this._acosTouchHandler.bind(this));
    WRAP.Geo.addEventHandler('boundsChange', this._updateBounds.bind(this));
  }

  async drawLayer(visible) {
    this.visible = visible;
    if(!this.ready) {
      await this.initialize();
    }
    this.setVisible(this.visible);
  }

  getLayer() {
    return this._allLayers();
  }
  _allLayers() {
    return [
      this.ashLayer,
      this.rankLayer,
      this.labelLayer
    ]
  }

  setVisible(visible) {
    if(!this.ready) return;

    if(this.ashLayer.visible() === visible) {
      return;
    }

    if(visible) {
      this.ashLayer.show();
      this.rankLayer.show();
      this.labelLayer.show();
    } else {
      this.ashLayer.hide();
      this.rankLayer.hide();
      this.labelLayer.hide();
      this._removePopup();
    }

    if (this.dhAutoUpdate !== visible) {
      this.dhAsh.setAutoUpdate('datalist', visible);
      this.dhRank.setAutoUpdate('data', visible);
      this.dhAutoUpdate = visible;
    }

    this._updateTimeList();

    this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
  }

  initTimeController() {
    this.acosTimeController.addLayer(this.ashLayer);
    if (this.visible) {
      this.acosTimeController.setDisplayTime(this.validTime);
    }
  }

  getTimeController() {
    return this.acosTimeController;
  }

  setAutoRefresh(autoFlg) {
    if (autoFlg === this.autoRefresh) return;
    this.autoRefresh = autoFlg;
    if (!this.ready) return;
    this.dhAsh.setAutoUpdate('datalist', this.autoRefresh);
    this.dhRank.setAutoUpdate('data', this.autoRefresh);
  }

  _updateTimeList() {
    if (!this.validTimeList) return;

    if (this.autoRefresh) {
      this.acosTimeController.setCurrentTime(this.validTime);
    }

    this.acosTimeController.adjustCurrentTime();
    this.acosTimeController.invalidate();
  }

  _validateTime(displayTime, content) {
    const vt = nearValidTime(this.validTimeList, displayTime);

    if (vt) {
      const dateTime = new WRAP.Core.DateTime(vt);
      content.validtime = true;
      content.forEach(c => {
        c.ft = this._createFt(new WRAP.Core.DateTime(c.basetime), dateTime);
      })
      this.validTime = vt;
      return true;
    }
    return false;
  }

  getTimeInformation() {
    let flLabel = this.HGT_FL_MAPPING[this.level].FL_V;
    if (this.level === this.FL_ALL_VALUE) {
      flLabel = `FL ${flLabel}`;
    }
    const info = {
      id: Acos.NAME,
      label: `ACOS ${flLabel}`
    }
    if (this.isViewFtAll()) {
      info.validTime = "Valid: ----/--/-- --:--";
      info.validTimeFormatter = time => time;
    } else {
      info.validTime = this.validTime;
      info.validTimeFormatter = formatValidTime;
    }
    if (!this.timeInfoOpt) {
      this.timeInfoOpt = <AcosTimeControllerOption acos={this}></AcosTimeControllerOption>;
    }
    info.component = this.timeInfoOpt;
    return info;
  }

  getLegend() {
    return {
      id: Acos.NAME,
      label: 'ACOS',
      component: LegendAcos,
      contents: this
    }
  }

  getIndividualAltitude() {
    return {
      id: Acos.NAME,
      altitude: this.altitude,
      label: 'ACOS',
      tooltip: this._altitudeTooltip.bind(this)
    }
  }

  getAltitudeLabel() {
    return this._altitudeTooltip(this.altitude)
  }

  applyIndividualAltitude(altitude) {
    if(this.altitude !== altitude) {
      this.altitude = altitude;
      if(!this.ready) return;
      const level = this._convertAltitudeToNearFL(this.altitude)
      this.applyIndividualLevel(level);
    }
  }

  applyIndividualLevel(level) {
    if (this.level === level) return;
    this.level = level;
    if (!this.ready) return;
    this._updateDataset();
  }

  applyElapsed(elapsed) {
    this.elapsed = elapsed;

    if(!this.ready) return;

    this._selectBaseValidTime(this.dhAsh.retained.index);
  }

  applyPlanETD(etd) {
    this.etd = etd;

    if(!this.ready) return;

    this._selectBaseValidTime(this.dhAsh.retained.index);
  }

  changeRoutePointEditing(routePointEditing) {
    this.ashLayer.disableInteraction(routePointEditing);
    this.rankLayer.disableInteraction(routePointEditing);
  }

  _selectBaseValidTime(timeList) {

    if(!timeList) return;
    this.latestVolcanoList = [];
    let latestIssueDateTime = 0;
    let latestAnnouncedDate;
    // 各火山の最新のデータかつ、no_detection_flagが0のものに絞る
    Object.keys(timeList).forEach(key => {
      let volcanoData = timeList[key];
      const latestEruptedData = _orderBy(volcanoData, 'erupted_date', 'desc')[0];
      if(latestEruptedData.no_detection_flag !== 1) {

        this.latestVolcanoList.push({
          id: key,
          latestErupted: latestEruptedData.erupted_date,
          eruptedFlag: latestEruptedData.erupted_flag,
          floatingAshFlag: latestEruptedData.floating_ash_flag
        });
        volcanoData = latestEruptedData;

        // 火山中最新のissueDateを探す
        const issueDate = new WRAP.Core.DateTime(latestEruptedData.issued_date);
        if(!latestIssueDateTime || latestIssueDateTime.diff(issueDate) > 0) {
          latestIssueDateTime = issueDate;
        }

        // 火山中最新のannounced_dateを探す
        const announcedDate = new WRAP.Core.DateTime(latestEruptedData.announced_date);
        if(!latestAnnouncedDate || latestAnnouncedDate.diff(announcedDate) > 0) {
          latestAnnouncedDate = announcedDate;
        }

      } else {
        delete timeList[key];
      }
    });

    // 火山中最新のannounced_dateから24時間以内の噴火時刻を持つ火山に絞る
    this.latestVolcanoList = this.latestVolcanoList.filter(volcano => {
      const eruptedDate = new WRAP.Core.DateTime(volcano.latestErupted);
      const diff = eruptedDate.diff(latestAnnouncedDate);
      let filter = false;
      if (0 <= diff && diff <= this.ERUPTED_TIME_THRESHOLD) {
        filter = true;
      }
      return filter;
    });

    // 最新のAnnounceDateから24h分のvalidtimeをつくる
    if(latestAnnouncedDate.date.getUTCMinutes() < 30) {
      latestAnnouncedDate.date.setUTCMinutes(0,0,0);
    } else {
      latestAnnouncedDate.date.setUTCHours(latestAnnouncedDate.date.getUTCHours() + 1, 0, 0, 0);
    }
    this.validTimeList = [];
    for(let i = 0; i <= 24; i++) {
      this.validTimeList.push(latestAnnouncedDate.text());
      latestAnnouncedDate.date.setHours(latestAnnouncedDate.date.getHours() + 1);
    }

    const tmpTimeList = this.validTimeList.map(validTime => {
      return {
        "validtime": validTime,
        "validtime_msec": parseUTCDate(validTime).getTime()
      };
    });

    let targetTime;
    if(!this.etd) {
      if (!this.autoRefresh) {
        targetTime = this.acosTimeController.getCurrentTime();
      } else {
        targetTime = Date.now();
      }
    } else {
      targetTime = this.etd.getTime() + this.elapsed * 1000;
    }

    const sortedTimeList = _orderBy(tmpTimeList, [
      o => {
        return Math.abs(targetTime - o.validtime_msec);
      },
      'validtime'
    ], ['asc', 'desc']);

    const selectedTime = sortedTimeList[0];

    if(selectedTime && this.validTime !== selectedTime.validtime) {
      this.validTime = selectedTime.validtime;
      this._updateTimeList();
      // Layerのデータ更新
      this._updateDataset();
    }
  }

  _updateDataset() {

    this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});

    const volcanoList = [];
    const validDateTime = new WRAP.Core.DateTime(this.validTime);
    Object.keys(this.latestVolcanoList).forEach(key => {
      const volcano = this.latestVolcanoList[key];
      volcanoList.push({
        id: volcano.id,
        level: this.HGT_FL_MAPPING[this.level].FL_V,
        basetime: volcano.latestErupted,
        /**
         * 初回描画時に各火山に空のft配列を設定する。
         * タイムコントローラー対応で、初回描画時に噴煙のコンターが描画できなくなったためのハック。
         * AcosON時にデータロード完了と、タイムコントローラへAcos設定のタイミングで2度レンダリングが走るが
         * データロード完了時のレンダリングは、後続処理でタイムコントローラを設定した結果、レンダリングがスキップされる。
         * タイムコントローラーへの設定時はsetするコンテンツに差分が無いためレンダリングがスキップされ、結果コンターが描画されない。
         * ※厳密にはvalidtime=trueが付与されるため差分ができるが、JSON.stringifyで正規化されvalidtime=trueが欠落する為、比較時に差分なしとなる。
         * これを回避する為に初回のデータロード完了時のftを空にし、タイムコントローラへAcosを設定したタイミングでのレンダリングでコンターを描画する。
         */
        ft: this.firstDraw ? this._createFt(new WRAP.Core.DateTime(volcano.latestErupted), validDateTime) : []
      })
    });
    this.firstDraw = true;
    this.ashLayer.set(volcanoList, true);
  }

  _createFt(eruptedDateTime, validDateTime) {
    // FT:ALLが指定された場合は全FTを返す
    if(this.isViewFtAll()) {
      return [3, 6, 9, 12, 15, 18, 21, 24];
    }

    const diffTime = eruptedDateTime.diff(validDateTime);
    let ft = 0;
    if(diffTime < 0) {
      ft = 0;
    } else if(diffTime <= 3600 * 4.5) {
      ft = 3;
    } else if(diffTime <= 3600 * 7.5) {
      ft = 6;
    } else if(diffTime <= 3600 * 10.5) {
      ft = 9;
    } else if(diffTime <= 3600 * 13.5) {
      ft = 12;
    } else if(diffTime <= 3600 * 16.5) {
      ft = 15;
    } else if(diffTime <= 3600 * 19.5) {
      ft = 18;
    } else if(diffTime <= 3600 * 22.5) {
      ft = 21;
    } else if(diffTime <= 3600 * 27) {
      ft = 24;
    }
    return [ft];
  }

  _rankTooltip(f) {
    if (!f) {
      return null;
    }
    const prop = f.properties;
    const geo = f.geometry;
    let ft = ' --ft';
    if (geo) {
      const v = geo.coordinates[2];
      ft = ` ${Math.floor(v * 3.28084)}ft`;
    }
    if (prop) {
      return prop.name + ft;
    }
    return null;
  };

  _ashTooltip(param) {
    const prop = param.properties;

    let displayFl;
    if(prop.fl === "ALL") {
      const volcanoAsh = this.volcanoAsh3D[prop.id];
      let ashData;
      if(volcanoAsh) {
        ashData = volcanoAsh.data;
      }
      if(ashData && ashData[prop.basetime]) {

        const coordinates = ashData[prop.basetime].ft.find(f=>f.fth === prop.validtime).coordinates;
        if (!coordinates) {
          return null;
        }
        const minFlFt = this._meter2ft(coordinates[0][0][0][2]);
        const maxFlFt = this._meter2ft(coordinates[coordinates.length - 1][0][0][2]);
        displayFl = `${minFlFt}-${maxFlFt}`;
      }
    } else {
      displayFl = prop.fl.replace("FL", "");
    }

    const validtime = formatTimeZoneDate(prop.validtime, undefined, 'MM/DD hh:mmz');
    return `<div style="text-align: left;">FT=${prop.ft} FL=${displayFl} <br> ${validtime}<div>`;
  }

  _addLabel() {
    const fontSize = 12;
    const offsetX = 11;
    const offsetY = 18;
    const fillStyle = this.isDark ? "#FFF" : "#000";
    this.labelLayer.clear();
    const mask = WRAP.Geo.getMask();
    mask.clear();

    const features = this.dhRank.retained.data.features.concat();
    features.sort((a, b)=> {
      if(a.properties.index < b.properties.index) {
        return 1;
      } else if (a.properties.index > b.properties.index) {
        return -1;
      } else {
        return 0;
      }
    });
    features.forEach(feature => {
      const name = feature.properties.name;
      const textSize = WRAP.Geo.getTextMetrics(name, fontSize);
      const textWidth = textSize[0];
      const textHeight = textSize[1];
      const point = feature.geometry.coordinates.slice(0, feature.geometry.coordinates.length - 1);
      const eruptedVolcano = this.latestVolcanoList.find(e=> { return e.id===name && e.eruptedFlag === 1});
      if(!mask.intersectRect(point, offsetX, offsetY, textWidth, textHeight) || eruptedVolcano) {
        const volcanoLabel = new WRAP.Geo.Feature.Text({
          align: "left",
          fillStyle: fillStyle,
          fontSize: fontSize,
          offsetX: offsetX,
          offsetY: offsetY,
          point: point,
          text: name,
        });
        this.labelLayer.addFeature(volcanoLabel);
        mask.addRect(point, offsetX, offsetY, textWidth, textHeight);

        // 噴火フラグが立っている火山に噴火時刻のラベルを設定
        if(eruptedVolcano) {
          const eruptionTime = new WRAP.Geo.Feature.Text({
            align: "left",
            fillStyle: fillStyle,
            fontSize: fontSize,
            offsetX: -75,
            offsetY: 18,
            point: point,
            text: formatTimeZoneDate(eruptedVolcano.latestErupted, undefined, "YYYY/M/D HH:mmz").split(" ")
          })
          this.labelLayer.addFeature(eruptionTime);
        }
      }
    });
  }

  _altitudeTooltip(altitude) {
    return this._convertAltitudeToNearFL(altitude);
  }

  acosFL = [
    430,420,410,400,
    390,380,370,360,350,340,330,320,310,300,
    290,280,270,260,250,240,230,220,210,200,
    190,180,170,160,150,140,130,120,110,100,
    90,80,70,60,50,40,30,20,10,0
  ];
  _convertAltitudeToNearFL(altitude) {
    const near = this.acosFL.reduce((prev, curr) => {
      return Math.abs(curr - altitude) < Math.abs(prev - altitude) ? curr : prev
    });
    let fl;
    if(near === 0) {
      fl = "ALL";
    } else {
      fl = `FL${('000' + near).slice(-3)}`;
    }
    return fl;
  }

  _acosTouchHandler(layer, feature) {
    if(layer) {
      // 火山クリック
      if(layer.name() === Acos.RankLayerName) {
        let target = this.popupVolcanoList.find(v=>v.id === feature.geo.properties.name);
        if(!target) {
          return;
        }

        // Levelの選択値をmeter単位に変換
        const selectLevelMeter = Math.floor(ft2m(parseInt(this.HGT_FL_MAPPING[this.level].FL, 10) * 100));
        let targetDetail;
        // levelがALLでない場合は2D、それ以外は3Dを使用
        if(selectLevelMeter) {
          targetDetail = this.volcanoAsh3D[target.id];
        } else {
          targetDetail = this.volcanoAsh2D[target.id];
        }

        const latestData = Object.values(targetDetail.data).sort((a,b)=>{
          if(a.eruptedDate < b.eruptedDate) {
              return 1;
          }else if(a.eruptedDate > b.eruptedDate) {
              return -1;
          } else {
              return 0;
          }
        })[0];

        const announcedTime = (new WRAP.Core.DateTime(latestData.eruptedDate)).text('YYYY/MM/DD hh:mmZ');
        const flList = [];
        latestData.ft.forEach((ft, index) => {
          const fl = [];
          const tempFt = ('0' + ft.ft).slice(-2);
          // FT15と21は表示しない
          if(tempFt !== '15' && tempFt !== '21') {
            fl.push(<p key={`fl${index}`}>FT{tempFt}: {formatTimeZoneDate(ft.fth)}</p>);
            fl.push(<p key={`level${index}`}>Level: {this.HGT_FL_MAPPING[this.level].FL_V}</p>);

            // 選択中のLEVELに該当するデータに絞り込む
            var coordinates = '';
            if(selectLevelMeter) {
              coordinates = ft.coordinates.find(c=> {
                return c[0][0][2] >= selectLevelMeter;
              })
            } else {
              coordinates = ft.coordinates;
            }

            let coordinateText = "";
            if(coordinates) {
              coordinates[0].forEach(coordinate => {
                coordinateText += this._changeLatLonForView(coordinate[1], coordinate[0]);
                coordinateText += ' - ';
              });
              coordinateText = coordinateText.slice(0, -3);
            } else {
              coordinateText = 'NIL';
            }
            fl.push(<p key={`coordinate${index}`}>{coordinateText}</p>);
            flList.push(<div key={index} className="acos-popup-fl">{fl}</div>);
          }
        });

        if(!this.popup) {
          this.popup = document.createElement('div');
          document.getElementById('map-container').appendChild(this.popup);
        }
        reactDom.render(
          <Draggable>
            <div id="acos-popup" className="acos-popup">
              <div className="acos-popup-header">
                <div className="acos-popup-title">ACOS</div>
                <button className="acos-popup-close" onClick={this._closeClickHandler.bind(this)}>×</button>
              </div>
              <div className="acos-popup-announced-time">Announced Time {formatTimeZoneDate(announcedTime)}</div>
              <div className="acos-popup-detail">
                <p>Announced = {formatTimeZoneDate(announcedTime)}</p>
                <p>Volcano = {target.id}</p>
                <p>Loc = {this._changeLatLonForView(latestData.lat, latestData.lon)}</p>
                <p>Height = {Math.floor(m2ft(latestData.height))}ft</p>
                <p>Status Code = {latestData.statusCode}</p>
                <p>Erupted = {formatTimeZoneDate(announcedTime)}</p>
                <p>MAX VA Height = {Math.floor(m2ft(latestData.maxVaHeight))}ft</p>
                {flList}
              </div>
            </div>
          </Draggable>
        , this.popup);
        this.popup.style.display = "block";
      }
    }
  }

  _closeClickHandler() {
    this.popup.style.display = "none";
  }

  _removePopup() {
    if (!this.popup) {
      return;
    }
    // Reactコンポーネントをアンマウント
    reactDom.unmountComponentAtNode(this.popup);

    // DOM要素自体を削除
    this.popup.remove();

    this.popup = null;
  }

  _changeLatLonForView(lat, lon) {
    let sn = 'N';
    let ew = 'E';
    if(lat === 0) {
      sn = '';
    } else if(lat < 0) {
      sn = 'S';
    }
    lon = this._convertTo180lon(lon);
    if(lon === 0 || lon === 180 || lon === -180) {
      ew = '';
    } else if(lon < 0) {
      ew = 'W';
    }
    return sn + Math.abs(lat) + " " + ew + Math.abs(lon);
  }

  /**
   * 経度を180度表記に変換する
   * @param {number} lon 経度
   * @returns {number}
   */
  _convertTo180lon(lon) {

    // 180度以内だったら変換不要
    if(lon <= 180) {
      return lon;
    }
    // 小数点以下の桁数を取得
    const numList = (lon + '').split('.');
    let decimalLength = 0;
    if(numList[1] !== undefined) {
      decimalLength = numList[1].length;
    }
    // 整数値に変化、桁数を合わせて0度からの度数を算出
    const i = Math.pow(10, decimalLength);
    const converted180 = 180 * i;
    const calculationResult = -(converted180 - (lon * i - converted180));

    return calculationResult / i;
  }

  async _loadVolcanicAshConcVector() {

    return new Promise(resolve => {

      const promises = [];
      const wrapUrl = WrapOption().wrap_url;
      const ash2d = [];
      const ash3d = [];
      axios.get(`${wrapUrl}/WX_WNI_VolcanicAshConcVector/index.json?t=${new Date().getTime()}`, {
        errorHandle: {
          message: COMMUNICATE_ERROR_MESSAGE_ACOS_INDEX,
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
        }
      }).then((res) => {
        this.rankIndex = res.data.index;
        const volcanos = Object.keys(this.rankIndex);
        const d = Date.now();
        for(const volcano of volcanos) {
          promises.push(axios.get(`${wrapUrl}/WX_WNI_VolcanicAshConcVector/2D/${volcano}.json?t=${d}`, {
            errorHandle: {
              message: COMMUNICATE_ERROR_MESSAGE_ACOS_2D,
              replacement: {volcano: volcano},
              additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
            }
          }).then(res => {
            ash2d.push(res.data.features);
          }));
          promises.push(axios.get(`${wrapUrl}/WX_WNI_VolcanicAshConcVector/3D/${volcano}.json?t=${d}`, {
            errorHandle: {
              message: COMMUNICATE_ERROR_MESSAGE_ACOS_3D,
              replacement: {volcano: volcano},
              additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
            }
          }).then(res => {
            ash3d.push(res.data.features);
          }));
        }

        Promise.all(promises).then(refs => {
          this.volcanoAsh2D = this._shapeVolcanicAshConcVectorDetail(ash2d);
          this.volcanoAsh3D = this._shapeVolcanicAshConcVectorDetail(ash3d);
          resolve(refs);
        });
      });
    });
  }

  _shapeVolcanicAshConcVectorDetail(volcanosFeatures) {

    const ashConcVectorDetail = {};

    volcanosFeatures.forEach(volcanoFeatures => {
      let volcanoName = '';
      const volcanoData = {
        data: {}
      };
      volcanoFeatures.forEach(feature => {
        // properties.wrap_valid_dateが無ければヘッダー用のデータ
        if(!feature.properties.wrap_valid_date) {

          volcanoName = feature.name;

          if(!volcanoData.data[feature.erupted_date]) {
            volcanoData.data[feature.erupted_date] = {
              lat: feature.geometry.coordinates[1],
              lon: feature.geometry.coordinates[0],
              height: feature.geometry.coordinates[2],
              statusCode: feature.properties.index,
              eruptedDate: feature.erupted_date,
              issueDate: feature.issued_date,
              maxVaHeight: feature.properties.max_height,
              ft: []
            };
          }

        } else {
          const eruptedDate = new WRAP.Core.DateTime(feature.erupted_date);
          const valid = new WRAP.Core.DateTime(feature.properties.wrap_valid_date);
          const dateDiff = eruptedDate.diff(valid);
          const ftt = parseInt(dateDiff / (60 * 60), 10);

          volcanoData.data[feature.erupted_date].ft.push({
            fth: feature.properties.wrap_valid_date,
            coordinates: feature.geometry.coordinates,
            ft: ftt
          });
        }
      });
      ashConcVectorDetail[volcanoName] = volcanoData;
    });
    return ashConcVectorDetail;
  }

  /**
   *
   * @param {Number} meter
   * @returns
   */
  _meter2ft(meter) {
    const feet = m2ft(meter);
    const flooredFeet = Math.round(feet / 100);
    return ('0' + flooredFeet).slice(-3);
  }

  /**
   * popupWindowに詳細を表示する火山のリストを作る
   */
  _createPopupVolcanoList() {
    const nonFloatingAshVolcanoList = this.latestVolcanoList.filter(v=>v.floatingAshFlag === 0);
    this.popupVolcanoList = nonFloatingAshVolcanoList.filter(x => this.rankIndex[x.id]);
  }

  _updateBounds() {
    this._addLabel();
  }

  applyMapColor(mapColor, isDark) {
    this.isDark = isDark;
    if(this.ready) {
      this._addLabel();
    }
	}

  getLevels() {
    return this.HGTS;
  }
  getLevel() {
    return this.level;
  }
  setLevel(level) {
    this.applyIndividualLevel(level);
  }
  setViewFtAll(checked) {
    if (this.viewFtAll === checked) return;
    this.viewFtAll = checked;
    if (!this.ready) return;
    this._updateDataset();
    // 時制パネルのFT ALLのチェックボックスに反映させるためイベントを飛ばす
    this.exDispatcher(oldValue => {
      return { ...oldValue, ftAll: this.viewFtAll };
    });
  }
  isViewFtAll() {
    return this.viewFtAll;
  }
  getAnimating() {
    return this.acosTimeController.animating;
  }
}

export default Acos;

const useStyles = makeStyles(() => ({
  inputLabel: {
    fontSize: 12
  },
  checkbox: {
    padding: 0
  },
  fromControlLabel: {
    marginLeft: 5,
    height: 16,
    marginRight: 0
  }
}));

function AcosTimeControllerOption({acos}) {

  const [isViewFtAll, setViewFtAll] = useDisplayOperationState({
    path: `${WX_ID_ACOS}.ftAll`,
    key: 'value',
    function: 'setViewFtAll'
  }, acos.isViewFtAll());

  // FT ALLの更新を検知して再描画を行う
  const exState = useRecoilValue(exWxContentsState(WX_ID_ACOS));
  useEffect(() => {
    if (exState.ftAll !== undefined) {
      setViewFtAll(exState.ftAll);
    }
  }, [exState.ftAll, setViewFtAll]);


  const animating = useRecoilValue(contentsAnimatingStateWithId(WX_ID_ACOS));
  const { isMapOnly } = useLayoutState();

  const currentValid = useRecoilValue(contentsCurrentTimeStateWidthId(WX_ID_ACOS));
  useEffect(() => {
    const ftall = acos.isViewFtAll();
    setViewFtAll(ftall);
    // eslint-disable-next-line
  }, [currentValid]);

  const changeTimeType = useCallback((ftAll) => {
    acos.setViewFtAll(ftAll);
    setViewFtAll(ftAll);
  }, [acos, setViewFtAll]);

  useEffect(() => {
    //FT ALL表示、かつ断面図表示の場合、FT ALL表示をやめる
    if (isViewFtAll && !isMapOnly) {
      changeTimeType(false);
    }
  }, [isMapOnly, isViewFtAll, changeTimeType]);

  const classes = useStyles();

  const handleTimeTypeChange = (event) => {
    changeTimeType(event.target.checked);
  }

  return (
    <FormControlLabel className={classes.fromControlLabel}
      control={<Checkbox checked={isViewFtAll} onChange={handleTimeTypeChange} size='small' disabled={!isMapOnly || animating[WX_ID_ACOS]} className={classes.checkbox}/>}
      label={<span className={classes.inputLabel}>FT ALL</span>}
    />
  )
}
